import React from 'react';
import KnowledgeBaseContain from '../../Componant/Knowledgebase/KnowledgeBase';

const KnowledgeBase = () => {
  return (
    <div className='page-body'>
      <KnowledgeBaseContain />
    </div>
  );
};

export default KnowledgeBase;
